import * as React from 'react'
import {ThemedIcon} from '../components/themed-icon/ThemedIcon'
import {ReactComponent as Svg} from './images/delete.svg'

export function DeleteIcon() {
  return (
    <ThemedIcon size={18}>
      <Svg />
    </ThemedIcon>
  )
}
